import { BIRTH_DATE_PATTERN, Gender } from '@/constants'

export const getGenderPrefix = (gender: string) => {
  if (!gender) return ''

  switch (gender) {
    case Gender.Male:
      return 'Mr'
    case Gender.Female:
      return 'Ms'
    case Gender.Other:
      return 'Mx'
    default:
      return ''
  }
}

/**
 * Convert the `MM/DD/YYYY` the birth date input produces into the ISO 8601
 * `YYYY-MM-DD` the sign-up endpoint requires — it rejects anything else with a
 * 400. Birth date is optional, so an empty or half-typed value is omitted
 * rather than guessed: `new Date('05/17/')` would happily return year 2001.
 * Calendar validity is the form's `birthDate` rule, not this function's.
 * @param value
 */
export const toIsoBirthDate = (value: string): string | undefined => {
  const match = BIRTH_DATE_PATTERN.exec(value)
  if (!match) return undefined

  const [, month, day, year] = match
  return `${year}-${month}-${day}`
}
